import React, { useEffect, useState } from "react";
import { Button, Empty, message, Popconfirm, Table, Tooltip } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { LoadingOutlined, UserSwitchOutlined } from "@ant-design/icons";
import { translate } from "../../locale";
import UserServices from "../../services/UserServices";
import { useParams } from "react-router-dom";
import Company from "../../services/CompanyServices";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const CompanyProfessionals = ({ reload, onChange }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (reload > 0) {
      loadData();
    }
  }, [reload]);

  const loadData = async () => {
    setLoading(true);
    try {
      const response = await Company.getStaff(id, "eira-professional");
      if (response.status >= 200 && response.status < 300) {
        console.log("response", response.data.message);
        setData(response.data.message.map((i, k) => ({ ...i, key: k })));
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleDelete = async (data) => {
    setLoading(true);
    try {
      const response = await UserServices.deleteManagement(data.id);
      if (response.status >= 200 && response.status < 300) {
        message.success(
          translate(
            "El {0} se guardó exitosamente.",
            translate("usuario administrador")
          )
        );
        loadData();
      } else {
        message.error(response.data.message);
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
      message.error(e.message);
      setLoading(false);
    }
  };

  const handleUpgrade = async (data) => {
    setLoading(true);
    try {
      const _data = {
        username: data.username,
        rol: "eira-company-admin",
        subscriptions: [],
      };
      const response = await Company.updateStaff(_data);
      if (response.status >= 200 && response.status < 300) {
        message.success(
          translate(
            "El {0} se guardó exitosamente.",
            translate("usuario administrador")
          )
        );
        loadData();
        if (onChange) {
          onChange();
        }
      } else {
        message.error(response.data.message);
      }
      console.log("handleUpgrade", data);
      setLoading(false);
    } catch (e) {
      console.log(e);
      message.error(e.message);
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-6 justify-center">
          <Popconfirm
            title={translate("¿Estás seguro de eliminar el registro?")}
            okText={translate("Si")}
            cancelText={translate("No")}
            onConfirm={() => handleDelete(record)}
          >
            <Tooltip title={translate("Eliminar profesional")}>
              <Button
                type="text"
                icon={<DeleteOutlined />}
                size="small"
                className="border-0"
              />
            </Tooltip>
          </Popconfirm>
          <Popconfirm
            title={
              <div className="text-center">
                {translate(`¿Esta seguro que desea cambiar el rol de`)}
                <br />
                {record.first_name} {record.last_name}
                <br />
                {translate(`de profesional a administrador?`)}
              </div>
            }
            okText={translate("Si")}
            cancelText={translate("No")}
            onConfirm={() => handleUpgrade(record)}
          >
            <Tooltip title={translate("Cambiar a administrador")}>
              <Button
                type="text"
                icon={<UserSwitchOutlined />}
                size="small"
                className="border-0"
              />
            </Tooltip>
          </Popconfirm>
        </div>
      ),
      width: 100,
    },
    {
      title: translate("Usuario"),
      dataIndex: "username",
      key: "username",
      render: (_, record) => record.username,
      sorter: (a, b) => {
        if (a.username < b.username) return -1;
        if (a.username > b.username) return 1;
        return 0;
      },
    },
    {
      title: translate("Nombre"),
      dataIndex: "first_name",
      key: "first_name",
      render: (_, record) => record.first_name,
      sorter: (a, b) => {
        if (a.first_name < b.first_name) return -1;
        if (a.first_name > b.first_name) return 1;
        return 0;
      },
    },
    {
      title: translate("Apellido"),
      dataIndex: "last_name",
      key: "last_name",
      render: (_, record) => record.last_name,
      sorter: (a, b) => {
        if (a.last_name < b.last_name) return -1;
        if (a.last_name > b.last_name) return 1;
        return 0;
      },
    },
  ];
  return (
    <Table
      rowKey={(i) => i.key}
      dataSource={data}
      columns={columns}
      loading={
        loading ? { indicator: antIcon, className: "text-custom_blue" } : false
      }
      locale={{
        emptyText: <Empty description={translate("No hay datos")} />,
        sortTitle: translate("Ordenar"),
        triggerDesc: translate("Ordenar (descendente)"),
        triggerAsc: translate("Ordenar (ascendente)"),
        cancelSort: translate("Cancelar orden"),
      }}
    />
  );
};

export default CompanyProfessionals;
